module.exports = __webpack_public_path__ + "img/fsm.59c5190c.svg";